module.exports = __webpack_public_path__ + "img/product-detail.00d84f80.png";